import type { FilterFuseOptions } from "./types";

export const SHORT_QUERY_THRESHOLD = 0.2;
export const LONG_QUERY_THRESHOLD = 0.35;

export const FUSE_OPTIONS: FilterFuseOptions = {
    shouldSort: true,
    distance: 200,
    minMatchCharLength: 2,
    threshold: LONG_QUERY_THRESHOLD,
    includeScore: true,
    keys: [
        // weights sum must equal 1
        { name: "label", weight: 0.6 },
        { name: "keywords", weight: 0.3 },
        { name: "groups", weight: 0.1 },
    ],
};

export const MAX_SEARCH_FILTERS_RESULTS = 20;
